import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPaymentsMain } from './modules/ui/Main';

const PaymentsPage = (
  <SuspensePage>
    <PagesPaymentsMain />
  </SuspensePage>
);

export default PaymentsPage;
